import { useEffect, useState } from "react"
import { MdCheckBox, MdCheckBoxOutlineBlank, MdWebAssetOff } from "react-icons/md"
import { useNavigate, useParams } from "react-router-dom"
import Spinner from "../../Components/Spinner"
import Warning from "../../Components/Warning"
import { addGuestToGroupDoc, checkUserWhereEmail, createGuestDoc, deleteGuestDoc, getEventDoc, getExhibitorsDocWhereEvent, getGuestsWhereEmailAndEvent, getMeetingGroupDoc } from "../../Requests/firebaseFirestore"
import { newGuestContact, sendGuestConfirm, sendMeetingNotification } from "../../Requests/sendMail"
import { useTranslation } from "react-i18next"

export default function EventInvitationFormPage() {
  const {eventId} = useParams()
  const [event, setEvent] = useState({})
  const [loading, setLoading] = useState(true)
  const [response, setResponse] = useState([])
  const [warning, setWarning] = useState({state: false, message:''})
  const [exhibitors, setExhibitors] = useState([])
  const [meetingReqs, setMeetingReqs] = useState([])
  const [exhSelId, setExhSelId] = useState([])
  const [error, setError] = useState('')
  const [sending, setSending] = useState(false)
  const navigate = useNavigate()
  const {t} = useTranslation()
  
  useEffect(()=>{
    document.body.className = document.body.className = 'bg-image'
  })

  const getExhibitors = async (event) => {
    const res = await getExhibitorsDocWhereEvent(event)
    return res
  }

  const displayDate = () => {
    let dateParts = event.date.split('-')
    let date = new Date()
    date.setDate(parseInt(dateParts[2]))
    date.setMonth(parseInt(dateParts[1])-1)
    date.setFullYear(parseInt(dateParts[0]))
    if(navigator.language === 'es-ES'){
      return `${date.toLocaleDateString('es-ES', {weekday:'long'}) + ' ' + date.getDate()} de ${date.toLocaleString('es-ES', {month:'long'})} desde las ${event.startTime} hs.`
    }else{
      return `${date.toLocaleDateString(navigator.language, {weekday:'long'}) + ', ' + date.toLocaleString(navigator.language, {month:'long'}) + ' ' + date.getDate() + ' at ' + event.startTime}`
    }
  }

  const handleInputChange = (e) => {
    const {name, value} = e.target
    setResponse({...response,[name]: value})
  }

  const handleCheckboxChange = (e) => {
    const {name, value, checked} = e.target
    
    if(response[name]){
      let res = response[name]
      if(checked){
        res.push(value)
      }else{
        res = res.filter(option=>option!==value)
      }
      setResponse({...response, [name]:res})
    }else{
      setResponse({...response, [name]:[value]})
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSending(true)
    let guest = {}
    let res = []
    event.form.forEach((input, index)=>{
      switch (input.type) {
        case 'banner':
          break;
        case 'title':
          break
        default:
          if(input.id){
            guest = {...guest, [input.id]:response[index]}
          }
          if(response[index]===undefined&&input.id==='allowShareData'){
            res = [...res, {question:input.title, answer:true}]  
          }else{
            res = [...res, {question:input.title, answer:response[index]||''}]
          }
          break;
        }
      })

      const checkEmail = (email) => {
        const banned = ['info', 'admin', 'ventas', 'sales', 'administracion', 'soporte', 'contacto', 'sobre', 'about', 'login', 'sales', 'compras', 'marketing', 'contact', 'support', 'sistemas', 'rrhh', 'webmaster']
        let check = true
        banned.forEach((ban)=>{
          if(email.includes(ban+'@')){
            check = false
          }
        })
        return check
      }

      if(guest.allowShareData===undefined){
        guest.allowShareData = true
      }
      let accInUse = false
      const checkGuest = await getGuestsWhereEmailAndEvent(guest.email, eventId)
      if(checkGuest.length !== 0){
        accInUse = true
      }
      const checkUser = await checkUserWhereEmail(guest.email)
      if(checkUser){
        accInUse = true
      }
      if(accInUse){
        handleWarning('Este email ya ha sido usado para registrarse al evento. Si usted cargo anteriormente el formulario ya esta registrado. Si no lo hizo le solicitamos usar una email personal para registrarse.')
      } else if (!checkEmail(guest.email)){
        handleWarning('No es posible registrarse con un email genérico (que comience con info@, ventas@, etc), por favor, ingrese su email personal.')
      }else{
        newGuestContact(eventId, event, guest.email)
        const guestDocId = await createGuestDoc({...guest, formAnswers:res, event:eventId})
        const codeSent = await sendGuestConfirm({fullName:guest.name, email:guest.email, event:event, guestId:guestDocId})
        if(codeSent.status==='failed'){
          setError('No se pudo registrar')
          await deleteGuestDoc(guestDocId)
        }else{
          for(const meetReq of meetingReqs){
            
            sendMeetingNotification({email:meetReq.exhibitor.email, guest:guest, event:event, brands:[...meetReq.brands]})
            
            const res = await getMeetingGroupDoc({fullName:meetReq.exhibitor.fullName, id:meetReq.exhibitor.id}, {name:event.name, id:eventId})
            
            for(const group of res){
              await addGuestToGroupDoc(group.id, [...group.guests, {...guest}])
            }
            
          }
          navigate('/formsent')
        }
        
      }
    setSending(false)
  }

  const handleSingleCheck = (e) =>{
    const {name, checked} = e.target
    setResponse({...response, [name]:checked})
  }

  const handleWarning = (message) =>{
    if(message){
      setWarning({state:!warning.state, message:message})
    }else{
      setWarning({state:!warning.state, message:''})
    }
  }

  const handleMeeting = (e) =>{
    const {value, checked} = e.target
    if(checked){
      setExhSelId([...exhSelId, exhibitors[value].id])
      setMeetingReqs([...meetingReqs, {exhibitor:{id:exhibitors[value].id, fullName:exhibitors[value].fullName, email:exhibitors[value].email}, brands:[]}])
    }else{
      setExhSelId(exhSelId.filter(id=>id!==exhibitors[value].id))
      let i = -1;
      let meets = meetingReqs
      meetingReqs.forEach((req, index)=>{
        if(req.exhibitor.id === exhibitors[value].id){
          i = index;
        }
      })
      meets.splice(i, 1)
      setMeetingReqs([...meets])
    }
  }

  useEffect(()=>{
    const getEvent = async ()=>{
      const ev = await getEventDoc(eventId)
      setEvent(ev)
      if(ev){
        let exh = await getExhibitors({name:ev.name, id:eventId})
        setExhibitors(exh.sort((a,b) => (a.company > b.company) ? 1 : ((b.company > a.company) ? -1 : 0)))
      }
      setLoading(false)
      
    }
    getEvent()
  },[eventId])


  const handleSelectBrand = (e) => {
    const {value, checked} = e.target
    let {exhibitor, brand} = JSON.parse(value)

    let i = -1;
    meetingReqs.forEach((req, index)=>{
      if(req.exhibitor.id === exhibitor.id){
        i = index
      }
    })
    if(checked){
      if(i === -1){
        setMeetingReqs([...meetingReqs, {exhibitor, brands:[brand]}])
      }else{
        let meets = meetingReqs
        let meet = meetingReqs[i]
        meet.brands = [...meet.brands, brand]
        meets[i] = meet
        setMeetingReqs([...meets])
      }
    }else{
      let meets = meetingReqs
      let meet = meets[i]
      meet.brands = meet.brands.filter(brnd=> brnd !== brand)
      setMeetingReqs([...meets])
    }
  }


  const displayInput = (input, masterIndex) => {
    let output = <></>
    switch (input.type) {
      case 'title':
        output = <div className="input-holder border-t-2 w-full py-4">
            <h1 className="font-semibold text-2xl text-center pb-1" key={masterIndex}>{input.title}</h1>
            {
              input.subtitle && input.subtitle !== '' ?
              <h1 className="w-[75%] mx-auto">{input.subtitle}</h1>
              :<></>
            }
          </div>
        break;
      case 'banner':
        output=<img className='rounded-[10px]' src={input.imageUrl} alt="banner" key={masterIndex}/>
        break;
      case 'text':
        output = <>
        {input.title.length>40?<label className="block w-[75%] mx-auto font-medium" htmlFor={input.id?input.id:masterIndex}>{input.title}</label>:''}
        <div className="input-holder w-[75%]" key={masterIndex}>
          <input type='text' name={masterIndex} id={input.id?input.id:masterIndex} required={input.required} onChange={handleInputChange}></input>
          {input.title.length<=40?<label htmlFor={input.id?input.id:masterIndex}>
            {input.id === 'name'? t('fullName'):''}
            {input.id === 'company'? t('company'):''}
            {input.id === 'fiscalId'? t('fiscalId'):''}
            {input.id === 'position'? t('position'):''}
            {input.id === 'phone'? t('phoneNumber'):''}
            {input.id === 'location'? t('location'):''}
            {!input.id?input.title:''}
          </label>:''}
        </div>
        </>
        break;
      case 'textarea':
        output = <div className="input-holder w-[75%]" key={masterIndex}>
          <textarea name={masterIndex} id={input.id?input.id:masterIndex} placeholder=' ' required={input.required} onChange={handleInputChange}></textarea>
          <label htmlFor={input.id?input.id:masterIndex}>{input.title}</label>
        </div>
        break;
      case 'email':
        output = <div className="input-holder w-[75%]" key={masterIndex}>
          <input type='email' name={masterIndex} id={input.id?input.id:masterIndex} required={input.required} onChange={handleInputChange}></input>
          <label htmlFor={input.id?input.id:masterIndex}>
            {input.id === 'email'? t('email'):
            input.title}
          </label>
        </div>
        break;
      case 'select':
        output = <div className="input-holder w-[75%]" key={masterIndex}>
          <select type='text' name={masterIndex} id={masterIndex} required={input.required} onChange={handleInputChange} defaultValue=''>
            <option value="" disabled hidden></option>
            {input.options.map((option, index) => {
              return(
                <option value={option} key={index}>{option}</option>
              )
            })}
          </select>
          <label htmlFor={masterIndex}>{input.title}</label>
        </div>
        break;
      case 'checkbox':
        output = <div className="input-holder w-[75%]" key={masterIndex}>
          <h1 className="py-2 text-md font-medium">
          {input.id === 'allowShareData'? t('permissions'):input.title}
          </h1>
          {input.options.map((option, index) => {
            return(
              <div key={index} className="options-holder my-2">
                <input type='checkbox' name={masterIndex} value={option}  id={`${masterIndex}-${index}`} onChange={input.id==='allowShareData'?handleSingleCheck:handleCheckboxChange} defaultChecked={input.id==='allowShareData'}></input>  
                <label htmlFor={`${masterIndex}-${index}`} className='flex gap-2'>
                  <span className="unselected"><MdCheckBoxOutlineBlank size={25}/></span>
                  <span className="selected"><MdCheckBox size={25}/></span>
                    {input.id === 'allowShareData'? t('consentText'):option}
                </label>
              </div>
              )
            })}
        </div>
        break;
      case 'radio':
        let options = []
        for (let a = 1; a <= 5; a++) {
          options = [...options, <div className="flex flex-row sm:flex-col gap-3 ml-3 sm:ml-0" key={a}><label className="w-fit sm:w-full text-center" htmlFor={`${a}-${masterIndex}`} key={a}>{a}</label><input className="w-fit" type='radio' id={`${a}-${masterIndex}`} name={masterIndex} value={a} onChange={handleInputChange}/></div>]
        }
        options = [<span>{input.minTag}</span>, ...options, <span>{input.maxTag}</span>]
        output = <div className="input-holder w-[100%] my-4" key={masterIndex}>
        <h1 className="py-2 w-[75%] mx-auto text-md font-medium">{input.title}</h1>
        <fieldset className="">
        <div className="flex flex-col sm:flex-row justify-evenly mx-6 sm:mx-0">
          {options.map((option) =>{return(option)})}
        </div>
        </fieldset>
        </div>
        break;
      default:
        output = <h1 key={masterIndex}>not yet</h1>
        break;
    }
    return output
  }

  return(
    <div className="container mx-auto px-4 mt-[100px]">

      {loading?
      <div className="text-white">
        <Spinner/>
      </div>:
      <>
      {event?
      <>
      <h1 className="text-center text-white text-3xl w-[75%] min-w-[350px] max-w-[1000px] mx-auto mb-6 key={masterIndex} ">{t('inscriptionFor')} {event.name}</h1>
      <div className="bg-white rounded-[10px] mb-[300px] w-[75%] min-w-[350px] max-w-[1000px] mx-auto px-2 py-2">
        <form className="flex flex-col gap-3" onSubmit={handleSubmit}>
          {event.form.map((input, index)=>{
            return displayInput(input, index)
          })}
          {exhibitors.length>0?
          <>
          <h1 className="input-holder font-semibold text-2xl py-4 border-t-2 w-full text-center">{t('requestMeeting')}</h1>
          <div className="input-holder w-[75%]">
            <h1 className="py-2 text-lg font-medium">{t('meetingInputTitle')}</h1>
            <span>{t('meetingInputText')}</span>
            {exhibitors?<>
              {exhibitors.map((exhibitor, masterIndex)=>{
                return(
                  <>
                  <div key={masterIndex} className="options-holder my-2">
                    <input type='checkbox' value={masterIndex} id={`exhibitor-${masterIndex}`} onChange={handleMeeting}></input>  
                    <label htmlFor={`exhibitor-${masterIndex}`} className='flex gap-2'>
                      <span className="unselected"><MdCheckBoxOutlineBlank size={25}/></span>
                      <span className="selected"><MdCheckBox size={25}/></span>
                      {exhibitor.company}
                    </label>
                  </div>
                  {exhSelId.includes(exhibitor.id)?<>

                    {exhibitor.brands.map((brand, index)=>{
                      if(brand.id===eventId&&brand.brands.length!==0){
                        return(
                          <span key={index}>{t('specifyBrand')}:</span>
                        )
                      }else{
                        return ''
                      }
                    })}

                  <div className="flex flex-col ml-[50px]">
                    {exhibitor.brands.map((brand, index)=>{
                      if(brand.id===eventId){
                        return(brand.brands.map((brnd, i)=>{return(
                          <div key={`brand-${masterIndex}-${i}-${index}`} className="options-holder my-2">
                            <input type='checkbox' value={JSON.stringify({exhibitor:{id:exhibitor.id, fullName:exhibitor.fullName, email:exhibitor.email}, brand:brnd})} id={`brand-${masterIndex}-${i}`} onChange={handleSelectBrand}></input>  
                            <label htmlFor={`brand-${masterIndex}-${i}`} className='flex gap-2'>
                              <span className="unselected"><MdCheckBoxOutlineBlank size={25}/></span>
                              <span className="selected"><MdCheckBox size={25}/></span>
                              {brnd}
                            </label>
                          </div>
                        )}))
                      }else{
                        return ''
                      }
                    })}
                  </div></>:<></>}
                  </>
                )
            })}</>
            :<></>}
          </div>
            </>
        :<></>}
        {error!==''?
        <span className="block mx-auto text-red-500">{error}</span>
        :<></>}

        <div className="input-holder border-t-2 w-full py-4 text-center">
            <h1 className="font-semibold text-2xl text-center pb-1">{t('weAreWaiting')} {displayDate()}</h1>
            <h1 className="font-semibold text-xl text-center pb-1">{event.description}</h1>
              <h1 className="w-[75%] mx-auto">{event.address}</h1>
              <h1 className="w-[75%] mx-auto">{event.city}, {event.region}</h1>
          </div>

              <button className="send-btn bg" disabled={sending}>{sending?t('loading'):t('send')}</button>
            <img src={event.footer} alt="footer" />
          </form>
      </div>
      </>
      :
      <div className="bg-white mx-auto w-[50%] min-w-[350px] rounded-[10px] px-4 py-3 flex flex-col justify-center items-center gap-4">
        <span className="text-rose-500"><MdWebAssetOff size={150}/></span>
        <h1 className="text-xl font-semibold">Error</h1>
        <span className="text-center text-lg">{t('noEventFound')}</span>
      </div>
      }
      </>}
      <Warning isActive={warning.state} handle={handleWarning} title={warning.message}/>
    </div>
  )
}